module.exports = __webpack_public_path__ + "static/pic01-55e1797fd15a7113b2be5a8fc1363d93.jpg";